import { Component, OnInit, inject } from '@angular/core';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {DossierDesistementAdminRequest} from '../../../class/api/DossierDesistementAdminRequest';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {DateService} from "../../../core/services/date.service";

@Component({
    selector: 'app-modal-desistement-admin',
    templateUrl: './modal-desistement-admin.component.html',
    styleUrls: ['./modal-desistement-admin.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatFormField, MatLabel, MatInput, FormsModule, MatDialogActions, MatButton, MatDialogClose, TranslateModule, ReactiveFormsModule]
})
export class ModalDesistementAdminComponent implements OnInit {
    private dialogRef = inject<MatDialogRef<any>>(MatDialogRef);
    private hydraService = inject(HydraService);
    data = inject(MAT_DIALOG_DATA);


    public mouvements: any[] = [];
    public commentaire = '';
    public selectedMouvement = null;
    public dateDesistement?: string | null = null;
    public errors: string[] = [];


    ngOnInit(): void {
    }

    saveDesistement() {
        this.errors = [];
        if (this.commentaire && this.commentaire.trim().length > 0 && this.dateDesistement && this.dateDesistement != '') {

            const bruteData = {
                dossier: this.data['@id'],
                mouvement: this.selectedMouvement,
                commentaire: this.commentaire,
                dateDesistement: DateService.getIsoDate(this.dateDesistement)
            };

            const desistement = new DossierDesistementAdminRequest(bruteData);

            //envoi des infos en back
            this.hydraService
                .post(api.desistementAdmin, desistement)
                .subscribe(() => {
                        this.dialogRef.close(this.dateDesistement);
                    }
                );
        }
        if (!this.dateDesistement || this.dateDesistement == '') {
            this.errors.push('Merci de renseigner une date de désistement');
        }
        if (!this.commentaire || this.commentaire.trim().length === 0) {
            this.errors.push('Merci de renseigner un commentaire pour le désistement');
        }
    }
}
